import {DealOriginDao} from '../../dao';
import {DealOriginModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateDealOrigin(
    userData: Record<string, string>,
    dealOriginId: number,
    update: Record<string, any>
) {
    try {
        const result = await DealOriginDao.updateDealOriginById(userData.userToken, dealOriginId, update);

        const resultParsed = DealOriginModel.parseDealOrigin(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
